// extracted by mini-css-extract-plugin
export default {"footer":"kwofLVZKls4HX2nAMYsY"};